import { useParams } from "react-router-dom";
import React, { useState, useEffect } from "react";
import FormElement from "../components/FormBuilder/FormElement";
import { Grid, Paper, Box, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { FormProvider } from "../FormContext";
import SignatureFileFillElement from "../components/FormFillDownloadElements/SignatureFileFillElement";
import RadioSelectionFillElement from "../components/FormFillDownloadElements/RadioSelectionFillElement";
import CheckboxFillElement from "../components/FormFillDownloadElements/CheckboxFillElement";
import HorizontalContainerFillElement from "../components/FormFillDownloadElements/HorizontalContainerFillElement";
import { fetchContractData } from "../api/contractVersionService";
import { USERROLE } from "../utils/commonConstant";
import { green, red } from "@mui/material/colors";

const ContractDownloadPage = () => {
  const { fileId } = useParams();
  const [elements, setElements] = useState([]);
  const ToCaptureRef = React.useRef();
  async function fetchData() {
    const formData = await fetchContractData(fileId);
    if (!formData) return;
    setElements(formData);
  }
  const insertInlineCSS = () => { };
  const [columnVisibilityModel, setColumnVisibilityModel] = useState({
    id: false,
  });
  const [rows, setRows] = useState([]);
  const sortModel = [
    {
      field: "id", // Sort by the FileName column
      sort: "asc", // 'asc' for ascending order, 'desc' for descending
    },
  ];
  const columns = [
    {
      field: "change",
      headerName: "Change",
      headerClassName: "bold-header",
      width: 200,
      renderCell: (params) => {
        params.changeType === 'Added' ? (<span style={{ color: green[500] }}>params.change</span >) : (<span style={{ color: red[500] }}>params.change</span >)
      }
    },
    {
      field: "changedBy",
      headerName: "Text Changed By",
      width: 160,
      headerClassName: "bold-header",
    },
    {
      field: "comments",
      headerName: "Comments",
      width: 200,
      headerClassName: "bold-header",
    },
    {
      field: "addedBy",
      headerName: "Comment Added By",
      width: 200,
      headerClassName: "bold-header",
    },
  ];
  useEffect(() => {
    const handleLoad = () => {
      setTimeout(() => {
        if (elements.length > 0) {
          insertInlineCSS();
        }
      }, 1000);
    };

    if (document.readyState === "complete") {
      handleLoad();
      let comments = [];
      elements.forEach(el => {
        let tcComments = el.props?.trackChangesComments;
        if (tcComments && Object.keys(tcComments).length !== 0) {
          Object.keys(tcComments).forEach(key => {
            if (tcComments[key].length > 0) {
              tcComments[key].forEach(cKey => {
                if (cKey.status) {
                  comments.push({
                    id: key,
                    text: cKey.visibilityFor.includes('Markel') ? cKey.text : '',
                    addedBy: cKey.userName,
                  })
                }
              })
            }
          })
        }
      })
      let rows = [];
      const trackChangesClass = document.querySelectorAll(
        ".track-changes.added,.track-changes.deleted,.track-changes.modified"
      );
      trackChangesClass.forEach(change => {
        change.setAttribute("data-hidden", " ");
        comments?.forEach(cmt => {
          if (cmt.id === change.attributes?.['data-change-id'].value) {
            rows.push({
              id: rows.length + 1,
              change: `${change.className.includes('added') ? 'Added' : 'Deleted'}: ${change.innerText}`,
              changeType: change.className.includes('added') ? 'Added' : 'Deleted',
              comments: cmt.text,
              addedBy: cmt.addedBy,
              changedBy: change.attributes?.['data-user-name']?.value,
            })
          }
        })
      })
      setRows(rows);
    } else {
      window.addEventListener("load", handleLoad);
    }
    return () => {
      window.removeEventListener("load", handleLoad);
    };
  }, [elements]);

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <FormProvider>
      <Box
        position="relative"
        minHeight="100vh"
        sx={{
          backgroundColor: "#CCCCCC",
        }}
      >
        <Grid container justifyContent="center" ref={ToCaptureRef}>
          <Grid item xs={12} md={8}>
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Paper elevation={3} sx={{ padding: 2, minHeight: "700px", boxShadow: "none", borderRadius: 0 }}>
                    <Grid container spacing={2}>
                      {elements.map((element, index) => (
                        <Grid
                          xs={12}
                          item
                          key={element.id}
                          sx={{
                            ...(element.type === "signature" ||
                              element.type === "fileUpload"
                              ? { pageBreakInside: "avoid" }
                              : {}),
                            ...(element.type === "logo" && {
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }),
                          }}
                        >
                          {element.type === "fileUpload" ? (
                            <SignatureFileFillElement element={element} />
                          ) : element.type === "radioSelection" ? (
                            <RadioSelectionFillElement element={element} />
                          ) : element.type === "checkBox" ? (
                            <CheckboxFillElement element={element} />
                          ) : element.type === "horizontalContainer" ? (
                            <HorizontalContainerFillElement element={element} />
                          ) : (
                            <FormElement
                              element={element}
                              dragHandle={false}
                              formPreview={true}
                              trackChangeDisplayBy={USERROLE.ADMIN}
                              isShowTrackHistory={true}
                            />
                          )}
                        </Grid>
                      ))}
                    </Grid>
                    <Box container spacing={2}>
                      <Typography variant="h6" sx={{ textAlign: "center", fontWeight: "bold" }}>
                        Tracked Change History
                      </Typography>
                    </Box>
                    <Grid container spacing={2} style={{ marginTop: "1rem", marginBottom: '2rem' }}>
                      <DataGrid
                        rows={rows}
                        columns={columns}
                        initialState={{
                          pagination: {
                            paginationModel: {
                              pageSize: 100,
                            },
                          },
                        }}
                        pageSizeOptions={[10, 50, 100]}
                        disableSelectionOnClick
                        columnVisibilityModel={columnVisibilityModel}
                        onColumnVisibilityModelChange={(newModel) =>
                          setColumnVisibilityModel(newModel)
                        }
                        sortModel={sortModel} // Set initial sort model
                        hideFooter
                      />
                    </Grid>
                  </Paper>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </FormProvider>
  );
};

export default ContractDownloadPage;
